import {useEffect, useState} from "react";
import ValuationAddressList from "./ValuationAddressList";
import AddressSearchFunctions from "../../utils/AddressSearchFunctions";
import PropertyDetails from "./PropertyDetails";
import val_api from "../../api/valuation";


const FINVISEInputBar = (props) => {
    const evaluate = props.evaluate;
    const manual_evaluate = props.manual_evaluate

    // Values
    const [selectedProperty, setSelectedProperty] = useState(null);
    const selectedType = props.selectedType

    // Address Selector
    const [displayAddress, setDisplayAddress] = useState("");
    const [listAddresses, setListAddresses] = useState([]);
    const [showListAddresses, setShowListAddresses] = useState(false);
    const [onlyPostcodes, setOnlyPostcodes] = useState(false)

    // Manual Addresses
    const [showManualPopup, setShowManualPopup] = useState(false);

    // Additional details
    const [showPropertyDetails, setShowPropertyDetails] = useState(false);
    // Residential Optional
    const [bedrooms, setBedrooms] = useState(0)
    const [yearBuilt, setYearBuilt] = useState("")
    const [propertyType, setPropertyType] = useState()
    const [uprn, setUprn] = useState("")
    const [propertyTypes, setPropertyTypes] = useState([])

    useEffect(() => {
        getPropertyTypes()
    }, [])

    const validateFields = () => {
        return (selectedProperty && selectedProperty.property_id) && (selectedType && selectedType.id)
    }

    const getPropertyTypes = () => {
        let response = val_api.getFinvisePropertyTypes();
        response.then(response => {
            setPropertyTypes(response.data.types)
        }).catch(err => console.log(err))
    }

    const handleRequestValuation = async () => {
        if (!validateFields) return
        let _body = {
            property_id: selectedProperty && selectedProperty.property_id,
            type: selectedType && selectedType.id,
            details: {
                "bedrooms": bedrooms && bedrooms ? bedrooms : "-",
                "yearBuilt": yearBuilt && yearBuilt ? yearBuilt : "-",
                "propertyType": propertyType && propertyType ? propertyType : "-",
                "uprn": uprn && uprn ? uprn : "-",
            }
        }
        evaluate(_body, displayAddress);
    }

    const hideListAddresses = () => {
        setShowListAddresses(false)
    }

    const selectAddress = (event) => AddressSearchFunctions.selectAddress(event.target.id, listAddresses,
        setDisplayAddress, setSelectedProperty, setShowListAddresses, setListAddresses)

    const selectPostcode = (event) => AddressSearchFunctions.selectPostcode(event.target.id, listAddresses,
        setDisplayAddress, setListAddresses, setShowListAddresses, setOnlyPostcodes)

    return (
        <>
            <div className="field-input">
                <div className="valuation-address-container">
                    <div className="valuation-address-bar">
                        <div className="valuation-address-entry 100">
                            <div className="valuation-field-container borderless">
                                <div className="valuation-type-title">
                                    Address
                                </div>
                                <input type="text"
                                       className="valuation-address-text"
                                       value={displayAddress}
                                       id="address-search"
                                       onChange={(ev) => setDisplayAddress(ev.target.value.toUpperCase())}
                                       placeholder="Type postcode"
                                       maxLength="10"
                                       onKeyUp={() => AddressSearchFunctions.handlePostcodeLookup(displayAddress,
                                           setShowListAddresses, setDisplayAddress, setSelectedProperty,
                                           setListAddresses, setOnlyPostcodes)}
                                       onClick={() => setShowListAddresses(true)}
                                       aria-label="Address search by postcode"
                                       data-1p-ignore
                                       data-lpignore
                                />
                            </div>
                            <div className="valuation-field-container finvise">
                                <div className={selectedProperty && selectedProperty ? "valuation-type-title link" : "valuation-type-title disabled"}>
                                    Property Details
                                </div>
                                <div className={selectedProperty && selectedProperty ? "valuation-type" : "valuation-type disabled"}
                                     onClick={() => setShowPropertyDetails(true)}>
                                    Further information
                                </div>
                                {showPropertyDetails && showPropertyDetails ?
                                    <PropertyDetails selectedType={selectedType}
                                                     bedrooms={bedrooms}
                                                     setBedrooms={setBedrooms}
                                                     uprn={uprn}
                                                     setUprn={setUprn}
                                                     yearBuilt={yearBuilt}
                                                     setYearBuilt={setYearBuilt}
                                                     propertyType={propertyType}
                                                     setPropertyType={setPropertyType}
                                                     propertyTypes={propertyTypes}
                                                     setShowPropertyDetails={setShowPropertyDetails}
                                    />

                                    : null
                                }
                            </div>
                            <input type="button"
                                   className={validateFields() ? "valuation-request-button" : "valuation-request-button disabled"}
                                   value={selectedType && "+ " + selectedType.description}
                                   onClick={() => handleRequestValuation()}
                                   disabled={!validateFields()}
                            />
                        </div>
                    </div>
                    <ValuationAddressList show={showListAddresses}
                                          manual_evaluate={manual_evaluate}
                                          selectedType={selectedType}
                                          allowManual={true}
                                          displayAddress={displayAddress}
                                          hide={hideListAddresses.bind(this)}
                                          listAddresses={listAddresses}
                                          onlyPostcodes={onlyPostcodes}
                                          selectAddress={selectAddress.bind(this)}
                                          selectPostcode={selectPostcode.bind(this)}
                                          showManualPopup={showManualPopup}
                                          setShowManualPopup={setShowManualPopup} />
                </div>
            </div>
        </>
    )
}

export default FINVISEInputBar